export const ru = {
    autoProlongation: 'Автопродление периода',
    avgBid: 'средняя цена клика за неделю',
    avgBidOpt: 'CPC в среднем за неделю',
    avgCpa: 'средняя цена конверсии за неделю',
    avgCpaOpt: 'CPA в среднем за неделю',
    avgCpi: 'средняя цена установки приложения',
    avgCpm: 'средняя цена за 1000 показов',
    bid: 'максимальная цена клика за неделю',
    clicksLimit: 'количество кликов в неделю',
    'day-budget-sum': 'сумма бюджета',
    default: 'Стандартный',
    filterAvgBid: 'CPC в неделю на каждый фильтр',
    filterAvgCpa: 'CPA в неделю на каждый фильтр',
    finish: 'окончание периода',
    maxCpa: 'максимальная конверсия',
    'maximum-number-impressions': 'Максимум показов по минимальной цене',
    'nedelnyy-byudzhet': 'Недельный бюджет',
    'nedelnyy-paket-klikov': 'Недельный пакет кликов',
    'on-both-platforms': 'на всех площадках',
    'on-net-platform': 'в сетях',
    'on-search-platform': 'на поиске',
    'optimizaciya-kolichestva-klikov-per-camp':
        'Оптимизация количества кликов на кампанию',
    'optimizaciya-kolichestva-klikov-per-filter':
        'Оптимизация количества кликов на каждый фильтр',
    'optimizaciya-kolichestva-konversiy-per-camp':
        'Оптимизация количества конверсий на кампанию',
    'optimizaciya-kolichestva-konversiy-per-filter':
        'Оптимизация количества конверсий на каждый фильтр',
    'po-vsem-tselyam': 'По всем целям',
    profitability: 'дохода составляет себестоимость товаров или услуг',
    profitabilityValue: '{profitability}%',
    reserveReturn: 'сэкономленного бюджета возвращать в рекламу',
    reserveReturnValue: '{reserveReturn}%',
    roiCoef: 'средняя рентабельность инвестиций за неделю',
    'ruchnoe-upravlenie-stavkami': 'Ручное управление ставками',
    'ruchnoe-upravlenie-stavkami-generic':
        'Ручное управление ставками (с оптимизацией в сетях)',
    'ruchnoe-upravlenie-stavkami-generic2':
        'Ручное управление ставками (с оптимизацией)',
    'ruchnoe-upravlenie-stavkami-s-optimizaciei':
        'Ручное управление с оптимизацией в сетях',
    'ruchnoe-upravlenie-stavkami2': 'Ручное управление ставками с оптимизацией',
    separateBidding: 'Раздельно управлять ставками на поиске и в сетях',
    showMode: 'режим показов',
    'snizhenie-tseny-povtornyh-pokazov': 'Снижение цены повторных показов',
    'srednyaya-cena-klika': 'Средняя цена клика',
    'srednyaya-cena-konversii': 'Средняя цена конверсии',
    'srednyaya-cena-ustanovki-prilozheniya':
        'Средняя цена установки приложения',
    'srednyaya-rentabelnost-investiciy-roi':
        'Средняя рентабельность инвестиций',
    start: 'начало периода',
    stretched: 'Распределённый',
    sum: 'недельный бюджет',
    tsel: 'Цель «{goalName}»',
    'vse-tseli': 'Все цели',
    'week-budget-max-clicks': 'Максимальное количество кликов',
    'week-budget-max-installations': 'Максимальное количество установок'
};
